import { render, staticRenderFns } from "./ModalModelSauvegarder.vue?vue&type=template&id=4f9059fc&scoped=true&"
import script from "./ModalModelSauvegarder.vue?vue&type=script&lang=js&"
export * from "./ModalModelSauvegarder.vue?vue&type=script&lang=js&"
import style0 from "./ModalModelSauvegarder.vue?vue&type=style&index=0&id=4f9059fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9059fc",
  null
  
)

export default component.exports